import React from 'react';
import nextGearCarGrey from '../../../assets/img/nextGear/next-gear-car-grey.svg';

function NextGearContactUsSection() {
  return (
    <section className="ng-contact-us">
      <div className="ng-contact-us__inner">
        <div className="ng-contact-us__content">
          <h4 className="ng-contact-us__title">Need Help?</h4>
          <p className="ng-contact-us__text">
            If you have questions about using NextGear Capital on The Stock Vault, our support
            team is here to help.
          </p>
          <div className="ng-contact-us__details">
            <p className="ng-contact-us__details-paragraph">
              Email:{' '}
              <span className="ng-contact-us__details-span">info@thestockvault.com</span>
            </p>
            <p className="ng-contact-us__details-paragraph">
              Phone: <span className="ng-contact-us__details-span">0303 0034714</span>
            </p>
          </div>
          <img src={nextGearCarGrey} alt="NextGear Icon" className="ng-contact-us__icon" />
        </div>
      </div>
    </section>
  );
}

export default NextGearContactUsSection;
